import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=e21c483a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e21c483a')) {
      api.createRecord('e21c483a', component.options)
    } else {
      api.reload('e21c483a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=e21c483a&", function () {
      api.rerender('e21c483a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fswtg47njH3X/JS/comp/FavElement.vue"
export default component.exports